import { SegmentProps } from './props';
import { Segment } from './Segment';

const FilledSegment = (props: SegmentProps) => (
  <Segment {...props} fillColor="grey" />
);

export { FilledSegment };
